import { observer } from 'mobx-react-lite'
import { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'

import { dmsState } from '@/app/store'
import { type IConpanyContract } from '@/app/types/dmsTypes'
import { BlurApp, Loader } from '@/shared'

import { emptyContract } from '../../helper'
import { EmptyContent } from '../EmptyContent/EmptyContent'
import { GoBack } from '../GoBack/GoBack'

import { CancelTransfer } from './CancelTransfer/CancelTransfer'
import style from './Contracts.module.scss'
import { Item } from './Item/Item'

export const Contracts = observer(() => {
    const { companyId } = useParams()
    const navi = useNavigate()

    const [newContract, setNewContract] = useState<IConpanyContract | null>(null)
    const [transferableContractError, setTransferableContractError] = useState<string | null>(null)

    const onTransferPoliciesHandler = (isIgnor: boolean = false) => {
        if (
            dmsState.transferableContractTargetIds.newСontractId &&
            dmsState.transferableContractTargetIds.oldСontractId
        ) {
            const dto = {
                oldСontractId: dmsState.transferableContractTargetIds.oldСontractId,
                newСontractId: dmsState.transferableContractTargetIds.newСontractId,
                isIgnor
            }
            dmsState.onTransferPolicies(
                dto,
                () => {
                    dmsState.onSetTransferableContractTargetIds({
                        newСontractId: null,
                        oldСontractId: null
                    })
                    setTransferableContractError(null)
                },
                setTransferableContractError
            )
        }
    }
    useEffect(() => {
        if (companyId && !dmsState.companyContracts) {
            dmsState.onGetCompanyContracts(companyId)
        }
        return () => {
            dmsState.onSetCompanyContracts(null)
        }
    }, [companyId])

    if (!dmsState.companyContracts) {
        return <Loader />
    }

    if (!companyId) {
        return null
    }

    const onAddNewItem = () => {
        setNewContract(emptyContract)
    }

    const insuranceCompanyName: string =
        dmsState.companiesList?.find((company) => company.id === companyId)?.name || 'Не известная компания'

    const onHandleGoBack = () => navi(-1)

    const onRejectTransferableContractError = () => {
        dmsState.onSetTransferableContractTargetIds({
            newСontractId: null,
            oldСontractId: null
        })
        setTransferableContractError(null)
    }

    if (dmsState.companyContracts.length === 0 && !newContract) {
        return (
            <>
                <GoBack onGoBack={onHandleGoBack} />
                <EmptyContent
                    title='Список договоров с СК пуст'
                    action={{
                        title: 'Добавить первый договор',
                        callback: onAddNewItem
                    }}
                />
            </>
        )
    }

    return (
        <div className={style.container}>
            {!!dmsState.transferableContractTargetIds.oldСontractId && (
                <BlurApp show={!!dmsState.transferableContractTargetIds} withScroll />
            )}
            {!!dmsState.transferableContractTargetIds.oldСontractId && !transferableContractError && (
                <CancelTransfer
                    callBack={() => {
                        dmsState.onSetTransferableContractTargetIds({
                            newСontractId: null,
                            oldСontractId: null
                        })
                        setTransferableContractError(null)
                    }}
                />
            )}
            {!newContract && (
                <div className={style.addContract}>
                    <button className={style.btn} onClick={onAddNewItem}>
                        Добавить договор
                    </button>
                </div>
            )}
            <GoBack onGoBack={onHandleGoBack} />
            <div className={style.insuranceCompanyName}>
                <span>{insuranceCompanyName}</span>
            </div>
            {newContract && (
                <Item
                    {...newContract}
                    mode='add'
                    onGetLastErrors={dmsState.onGetLastErrors}
                    onGetImportHistory={dmsState.onGetImportHistory}
                    isAllowedTransfer={false}
                    insuranceCompanyId={companyId}
                    transferableContractError={transferableContractError}
                    onZeroNewContract={() => setNewContract(null)}
                    setTransferableContractError={setTransferableContractError}
                    onRejectTransferableContractError={onRejectTransferableContractError}
                    onTransferPoliciesHandler={onTransferPoliciesHandler}
                />
            )}
            {!newContract &&
                dmsState.companyContracts.map((contract) => {
                    const { id } = contract
                    return (
                        <Item
                            key={id}
                            {...contract}
                            mode='change'
                            onGetLastErrors={dmsState.onGetLastErrors}
                            onGetImportHistory={dmsState.onGetImportHistory}
                            isAllowedTransfer={
                                (dmsState.companyContracts && dmsState.companyContracts?.length > 1) || false
                            }
                            insuranceCompanyId={companyId}
                            transferableContractError={transferableContractError}
                            setTransferableContractError={setTransferableContractError}
                            onRejectTransferableContractError={onRejectTransferableContractError}
                            onTransferPoliciesHandler={onTransferPoliciesHandler}
                        />
                    )
                })}
        </div>
    )
})
